const $ = require('jquery');
'use strict';
///*------------------------------------------
///*  заказ проекта 
///*------------------------------------------
const formProjectHandler = (() => { 
	$(document).on('change', '#orderCall input[name="valTrFal"]', function() {
	if($(this).val()==="valTrFal_true") {	 
	  $("#orderCall button[type=submit]").removeAttr('disabled');
	  $('#orderCall input[type=hidden].valTrFal').val('valTrFal_true');
	}
	else {
		$("#orderCall button[type=submit]").attr('disabled','disabled');
		$('#orderCall input[type=hidden].valTrFal').val('valTrFal_disabled');
	}
});
 
$("#orderCall").submit(function() {
	 if($('#orderCall input[name="valTrFal"]').val()!=="valTrFal_true") {
	 	$("#orderCall button[type=submit]").attr('disabled','disabled');
		$('#orderCall input[type=hidden].valTrFal').val('valTrFal_disabled');
	 }
 const data = $(this).serialize();
	$.ajax({
	type: "POST",
	url: "php/project.php",
	data: data,
	success: function(msg) {
		if(msg == 'ok') {
			$('.popup2, .overlay-f').css('opacity','1');
			$('.popup2, .overlay-f').css('visibility','visible');
			$('.popup-f').css({'opacity':'0','visibility':'hidden'});
			$('#orderCall textarea').val('');
			$(':input','#orderCall').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
			$('.popup2 .close-modal').click(function () {
				$('.popup-f, .popup2, .overlay-f').css({'opacity':'0', 'visibility':'hidden'});
			});
		}
		else {
			$('.popup2 .window').html(
			'<div class="insText"><h3 class="insText__title">Ошибка</h3><div class="insText__text">Сообщение не отправлено, убедитесь в правильности заполнения полей.</div></div>'); 
			$('.popup2, .overlay-f').css('opacity','1'); 
			$('.popup2, .overlay-f').css('visibility','visible'); 
			$('.popup-f').css({'opacity':'0','visibility':'hidden'});
			$('#orderCall textarea').val('');
			$(':input','#orderCall').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
			$('.popup2 .close-modal').click(function () {
				$('.popup-f, .popup2, .overlay-f').css({'opacity':'0', 'visibility':'hidden'});
			});
		} 
	} 
	}); 
	return false; 
	}); 
});
export default formProjectHandler;


// WEBPACK FOOTER //
// ./app/components/zakaz_project.js